(() => {
  if (window.AceiiQuickStartVideo) return;
  window.AceiiQuickStartVideo = true;

  const linkSelector = "[data-aceii-quick-start-video]";
  const modalId = "AceiiQuickStartVideoModal";

  const createModal = () => {
    const existingModal = document.getElementById(modalId);
    if (existingModal instanceof HTMLDialogElement) return existingModal;

    const modal = document.createElement("dialog");
    modal.id = modalId;
    modal.className = "aceii-quick-start-video-modal";
    modal.setAttribute("aria-label", "AceiiLab A1 setup tutorial");
    modal.innerHTML = `
      <div class="aceii-quick-start-video-modal__panel" data-aceii-quick-start-video-panel>
        <button
          type="button"
          class="aceii-quick-start-video-modal__close"
          aria-label="Close tutorial video"
          data-aceii-quick-start-video-close
        >
          <svg viewBox="0 0 24 24" aria-hidden="true">
            <path d="M5 5l14 14M19 5L5 19" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round"/>
          </svg>
        </button>
        <div class="aceii-quick-start-video-modal__media" data-aceii-quick-start-video-media></div>
      </div>
    `;
    document.body.append(modal);

    const panel = modal.querySelector("[data-aceii-quick-start-video-panel]");
    const media = modal.querySelector("[data-aceii-quick-start-video-media]");
    const closeButton = modal.querySelector("[data-aceii-quick-start-video-close]");

    const stopVideo = () => {
      media?.replaceChildren();
    };

    closeButton?.addEventListener("click", () => modal.close());
    modal.addEventListener("close", stopVideo);
    modal.addEventListener("click", (event) => {
      if (event.target !== modal || !panel) return;

      const bounds = panel.getBoundingClientRect();
      const clickedInsidePanel =
        event.clientX >= bounds.left &&
        event.clientX <= bounds.right &&
        event.clientY >= bounds.top &&
        event.clientY <= bounds.bottom;

      if (!clickedInsidePanel) modal.close();
    });

    return modal;
  };

  const openVideo = (link) => {
    const videoId = link.dataset.videoId;
    if (!videoId) return;

    const modal = createModal();
    const media = modal.querySelector("[data-aceii-quick-start-video-media]");
    if (!media) return;

    const iframe = document.createElement("iframe");
    iframe.src = `https://www.youtube-nocookie.com/embed/${encodeURIComponent(
      videoId
    )}?autoplay=1&rel=0&playsinline=1`;
    iframe.title = link.dataset.videoTitle || "AceiiLab A1 setup and tutorial";
    iframe.allow =
      "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share";
    iframe.referrerPolicy = "strict-origin-when-cross-origin";
    iframe.allowFullscreen = true;

    media.replaceChildren(iframe);
    modal.showModal();
  };

  const initialize = (link) => {
    if (!(link instanceof HTMLAnchorElement) || link.dataset.aceiiTutorialReady === "true") return;

    link.dataset.aceiiTutorialReady = "true";
    link.setAttribute("aria-haspopup", "dialog");
    link.setAttribute("aria-controls", modalId);
    link.addEventListener("click", (event) => {
      if (!link.dataset.videoId) return;
      event.preventDefault();
      openVideo(link);
    });
  };

  const scan = (scope = document) => {
    if (scope instanceof Element && scope.matches(linkSelector)) initialize(scope);
    scope.querySelectorAll?.(linkSelector).forEach(initialize);
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => scan(), { once: true });
  } else {
    scan();
  }

  document.addEventListener("shopify:section:load", (event) => scan(event.target));
})();
